import PropTypes from "prop-types";
import React from "react";

import AddRouteForm from "v2/components/responsive/AddRouteForm";

const AddRoutePage = (props, context) => {
  const {location: {query}, params: {date}, router} = context;
  return (
    <AddRouteForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}`,
          query,
        });
      }} />
  );
};

AddRoutePage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default AddRoutePage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/AddRoutePage.js
 **/